
import React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, SearchIcon, PlusIcon, UserIcon, SlidersIcon } from '../icons/Icons';
import { useAuth } from '../../contexts/AuthContext';

const MobileNavItem: React.FC<{ to: string; label: string; children: React.ReactNode }> = ({ to, children, label }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `flex flex-col items-center justify-center gap-1 p-2 transition-colors ${
        isActive ? 'text-accent' : 'text-muted-foreground hover:text-foreground'
      }`
    }
  >
    {children}
    <span className="text-xs font-medium">{label}</span>
  </NavLink>
);

const MobileNav: React.FC = () => {
    const { user } = useAuth();
    if (!user) return null;

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 flex h-16 items-center justify-around border-t border-border bg-card/80 backdrop-blur-sm">
      <MobileNavItem to="/dashboard" label="Home">
        <HomeIcon className="h-6 w-6" />
      </MobileNavItem>
      <MobileNavItem to="/forge" label="TheForge">
        <SlidersIcon className="h-6 w-6" />
      </MobileNavItem>
      <MobileNavItem to="/browse" label="Browse">
        <SearchIcon className="h-6 w-6" />
      </MobileNavItem>
       <NavLink
            to="/prompts/new"
            className="flex h-12 w-12 items-center justify-center rounded-full bg-accent text-accent-foreground shadow-lg -translate-y-4"
        >
            <PlusIcon className="h-6 w-6" />
            <span className="sr-only">Add Prompt</span>
        </NavLink>
        <MobileNavItem to={`/profile/${user.uid}`} label="Profile">
          <UserIcon className="h-6 w-6" />
        </MobileNavItem>
    </nav>
  );
};

export default MobileNav;
